import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

// Design guidelines (design_guidelines.md) - mapping status → label + style + testid
const STATUS_MAP = {
  requested: { label: "Demande reçue", cls: "bg-muted text-foreground", testid: "memorybook-status-badge-requested" },
  admin_scoping: { label: "Cadrage AITO", cls: "bg-muted text-foreground", testid: "memorybook-status-badge-admin-scoping" },
  data_ready: { label: "Données prêtes", cls: "bg-secondary text-secondary-foreground", testid: "memorybook-status-badge-data-ready" },
  draft_generated: { label: "Brouillon généré", cls: "bg-secondary text-secondary-foreground", testid: "memorybook-status-badge-draft" },
  admin_review: { label: "En relecture", cls: "bg-[hsl(var(--aito-gold))/0.14] text-[hsl(var(--aito-black))] border-[hsl(var(--aito-gold))/0.35]", testid: "memorybook-status-badge-admin-review" },
  copf_review: { label: "Soumis COPF", cls: "bg-muted text-muted-foreground", testid: "memorybook-status-badge-copf-review" },
  changes_requested: { label: "Corrections demandées", cls: "bg-[hsl(var(--warning))/0.14] text-[hsl(var(--aito-black))] border-[hsl(var(--warning))/0.35]", testid: "memorybook-status-badge-changes-requested" },
  finalized: { label: "Terminé", cls: "bg-[hsl(var(--success))/0.14] text-[hsl(var(--aito-black))] border-[hsl(var(--success))/0.35]", testid: "memorybook-status-badge-finalized" },
  copf_approved: { label: "Validé COPF", cls: "bg-[hsl(var(--aito-lagoon))/0.14] text-[hsl(var(--aito-black))] border-[hsl(var(--aito-lagoon))/0.35]", testid: "memorybook-status-badge-copf-approved" },
  rejected: { label: "Refusé", cls: "bg-[hsl(var(--destructive))/0.12] text-[hsl(var(--aito-black))] border-[hsl(var(--destructive))/0.35]", testid: "memorybook-status-badge-rejected" },
  archived: { label: "Archivé", cls: "bg-muted text-muted-foreground", testid: "memorybook-status-badge-archived" },
};

export const MemoryBookStatusBadge = ({ status, className }) => {
  const s = STATUS_MAP[status] || STATUS_MAP.requested;
  return (
    <Badge
      variant="outline"
      data-testid={s.testid}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-3 py-0.5 text-[11px] uppercase tracking-wide",
        s.cls,
        className
      )}
    >
      {s.label}
    </Badge>
  );
};

export const RoadTo2027Badge = ({ className }) => (
  <span
    data-testid="badge-road-to-2027"
    className={cn(
      "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs",
      "bg-[hsl(var(--aito-energy))/0.10] border-[hsl(var(--aito-energy))/0.35] text-foreground",
      className
    )}
  >
    <span className="h-2 w-2 rounded-full bg-[hsl(var(--aito-energy))]" />
    Jeux du Pacifique 2027
  </span>
);

export const CopfApprovedBadge = ({ className }) => (
  <span
    data-testid="badge-copf-approved"
    className={cn(
      "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs",
      "bg-[hsl(var(--aito-lagoon))/0.10] border-[hsl(var(--aito-lagoon))/0.35] text-foreground",
      className
    )}
  >
    <span className="h-2 w-2 rounded-full bg-[hsl(var(--aito-lagoon))]" />
    Validé COPF
  </span>
);

export const SIMPLIFIED_STATUS_MAP = STATUS_MAP;
